import Tick from '@pqina/flip';

const makeTickRussian = (tick) => {
  const locale = {
    YEAR_PLURAL: 'Лет',
    YEAR_SINGULAR: 'Год',
    MONTH_PLURAL: 'Месяцев',
    MONTH_SINGULAR: 'Месяц',
    WEEK_PLURAL: 'Недель',
    WEEK_SINGULAR: 'Неделя',
    DAY_PLURAL: 'Дней',
    DAY_SINGULAR: 'День',
    HOUR_PLURAL: 'Часов',
    HOUR_SINGULAR: 'Час',
    MINUTE_PLURAL: 'Минут',
    MINUTE_SINGULAR: 'Минута',
    SECOND_PLURAL: 'Секунд',
    SECOND_SINGULAR: 'Секунда',
    MILLISECOND_PLURAL: 'Миллисекунд',
    MILLISECOND_SINGULAR: 'Миллисекунда'
  };

  for (let key in locale) {
    if (!locale.hasOwnProperty(key)) { continue; }
    tick.setConstant(key, locale[key]);
  }
};

const initNode = (node) => {
  const tick = Tick.DOM.create(node, {
    didInit: function(tick) {
      makeTickRussian(tick);
      const counter = Tick.count.down(node.getAttribute('data-value'));
      counter.onupdate = function(value) { tick.value = value; };
    }
  });
};

const initAll = () => {
  const nodes = document.querySelectorAll('.tick:not([data-state="initialised"])');
  Array.from(nodes).forEach(node => initNode(node));
};

const start = () => {
  document.addEventListener('page:load', initAll);
  document.addEventListener('ajax:success', initAll);
};

export default { initAll, start };
